import { setupHandlers, setupInitialState, setupLocalState, setupServices, updateItemContext } from "../library/dataService";
import { INGComponentProps } from "../library/NGFieldExtensions";
import { SimpleContainer } from "../../resolvers-types";
import NGLayoutItem from "./NGLayoutItem";
import { GlobalStyles } from "@mui/material";
import { useSignal } from "@preact/signals-react";
import { renderModalPopups, setupReviewPopups } from "../components/ComponentUtils";
import { useEffect } from "react";
import { inUserFeed } from "../library/utils";
import { log } from "../library/logger";
import useReviewDialog from "../hooks/useReviewDialog";

const tag = "NGComponent";

export default function NGComponent({ config, context }: INGComponentProps) {
  const alreadyAdded = context.Path[context.Path.length - 1]?.Id === config.Id;
  const currentContext = alreadyAdded ? context : updateItemContext(context, config);

  if (!inUserFeed()) {
    config.Bindings = {
      ...config.Bindings,
      InReviewMode: `Global.User.Details.InReviewMode && ${config.IncludeInCatalog}`,
    };
  }

  const local = setupLocalState(
    config,
    {
      Visible: useSignal(true),
      Styles: useSignal(config.Styles ?? []),
      InReviewMode: useSignal(inUserFeed() ? config.ComponentContainer?.InReviewMode : config.InReviewMode ?? false),
    },
    currentContext
  );

  setupServices(config, currentContext);
  setupInitialState(config, currentContext);

  const handlers = setupHandlers(config, currentContext);

  useEffect(() => {
    log.info(tag, 'onLoad', config.Id, config.__typename, config);
    handlers["onLoad"]?.(config, config);
  }, []); // run once on mount

  const withReviewDialog = useReviewDialog(config, context, local.InReviewMode.value);

  const renderComponent = () => {
    return (
      <div data-testid={config.Id} data-type={config.__typename}>
        <GlobalStyles styles={{ ...local.Styles.value }} />
        <NGLayoutItem
          config={config.ComponentContainer as SimpleContainer}
          context={currentContext}
        />
      </div>
    )
  }

  return (
    <>
      {renderModalPopups(config, currentContext)}
      {setupReviewPopups(context)}
      {local.InReviewMode.value
        ? withReviewDialog(renderComponent())
        : renderComponent()
      }
    </>
  );
}
